import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';

@Component({
  selector: 'app-test-creator',
  templateUrl: './test-creator.component.html',
  styleUrls: ['./test-creator.component.scss']
})
export class TestCreatorComponent implements OnInit {

  exam: FormGroup;
  question: FormGroup;

  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');

  constructor(fb: FormBuilder, fb1: FormBuilder,
    private questionnaire: QuestionnaireService) {
    this.exam = fb.group({
      name: ['', Validators.minLength(10)],
      description: ['', Validators.minLength(10)],
      weighing: ['', Validators.pattern(/^[0-9]+$/)]
    });
    this.question = fb.group(
      {
        image: '',
        exam_id: 0,
        question_type: 0,
        question_id: 0,
        question: '',
        answer1: fb.group({
          is_answer: true,
          answer_image: '',
          answer_if_text: '',
          answer: '',
        }),
        answer2: fb.group({
          is_answer: false,
          answer_image: '',
          answer_if_text: '',
          answer: '',
        }),
        answer3: fb.group({
          is_answer: false,
          answer_image: '',
          answer_if_text: '',
          answer: ''
        })


      }
    );
  }
  exams = []
  ngOnInit(): void {

    this.questionnaire.getexams({}).subscribe(resolve => {
      this.exams = resolve
    })
  }


  sendExam() {
    if (this.exam.status == 'VALID') {
      console.log(this.exam.status)
      this.questionnaire.createExam(this.exam.value).subscribe((result) => {
        this.ngOnInit()
        this.exam.reset()
      },
        e => {
          console.log(e)
        })
    } else {
      console.log('error')
    }
  }

  sendQuestion() {
    console.log(this.question.value)
    let questionToSend = Object.assign({},this.question.value)
    delete questionToSend.answer2
    delete questionToSend.answer1
    delete questionToSend.answer3
    
    questionToSend.answers=[this.question.value.answer1,this.question.value.answer2,this.question.value.answer3]

    this.questionnaire.saveQuestionnaire([questionToSend]).subscribe(resolve => {
      console.log(resolve)
      this.ngOnInit()
      this.question.reset()
    },
      e => {
        console.log(e)
      })
  }

}